export const TABS_FIND_SKU_VALUE = {
	UPLOAD: 'upload',
	WRITE: 'write',
}

export const TABS_FIND_SKU = [
	{ value: TABS_FIND_SKU_VALUE.UPLOAD, label: 'Upload' },
	{ value: TABS_FIND_SKU_VALUE.WRITE, label: 'Write' }
]